import { routePaths } from 'components/Routes/data';
import { BulkUploadTypes, UploadTypeConfig, UploadTypeConfigCallback } from 'constants/bulkUpload';
import permissions from 'constants/permissions';

type ColumnsArray = NonNullable<UploadTypeConfig['preview']['columns']>;

const getColumns = (): ColumnsArray => [
  {
    title: 'Employee ID',
    render: (item) => item.file_row?.commonProperties?.employeeId ?? '-',
  },
  {
    title: 'Name',
    render: (item) => item.file_row?.commonProperties?.employeeName,
  },
  {
    title: 'Email Address',
    render: (item) => item.file_row?.commonProperties?.email,
  },
  {
    title: 'Reason for request',
    render: (item) => item.file_row?.reasonForRequest,
  },
  {
    title: 'Amount',
    render: (item) => item.file_row?.amount,
  },
  {
    title: 'Payment Status',
    render: (item) => item.file_row?.paymentStatus,
  },
  {
    title: 'Interest Type',
    render: (item) => item.file_row?.interestType,
  },
  {
    title: 'Interest rate',
    render: (item) => item.file_row?.interestRate ?? '-',
  },
  {
    title: 'Perquisite rate',
    render: (item) => item.file_row?.perquisiteRate ?? '-',
  },
  {
    title: 'Repayment tenure (months)',
    render: (item) => item.file_row?.repaymentTenure,
  },
  {
    title: 'EMI Deduction starts from',
    render: (item) => item.file_row?.emiStartsFrom,
  },
];

export const bulkLoansAdvancesConfig: UploadTypeConfigCallback = (data) => ({
  permissions: [permissions.PAYROLL_PAY_ADVANCE_SALARY],
  initiation: {
    permissions: [permissions.PAYROLL_PAY_ADVANCE_SALARY],
    feature: 'bulkLoansAdvances',
    pageTitle: 'Bulk Loans/Advances',
    step1Title: '1. Download the Loans/Advances template',
    step1Subtitle:
      'Download the template and open it in Excel. Add a row for each loan or advance (an employee can have multiple rows), then upload it here.',
    instructions: [
      'ADD new rows if the same employee has multiple loans/advances.',
      'DELETE rows for employees with no loans/advances.',
      'Interest rate and Perquisite rate are ignored when Interest Type is "Interest Free".',
      'Do not add or remove any columns.',
      'There is a limit of 500 rows per upload.',
      'Mandatory fields are mentioned with the * sign.',
    ],
    onSampleTemplateDownload() {
      window.open(`/v2/api/bulk-loans-advances/download-template`, '_blank');
    },
  },
  preview: {
    permissions: [permissions.PAYROLL_PAY_ADVANCE_SALARY],
    feature: 'bulkLoansAdvances',
    showColumnsSelector: false,
    columns: getColumns(),
    renderConfirmationText: () =>
      `Almost done! Please confirm to create the loans/advances for your employees.`,
    successModalCtaText: 'Go to Loans',
    successModalMainText: 'You have successfully created loans/advances for your employees.',
    successModalSubText: () => 'Need to make changes? Manage loans anytime from the “Loans” page.',
    onSuccessModalCtaClick() {
      data.history.push(routePaths.loansV2.root);
    },
    onDownloadErrorReport(history) {
      history?.push({
        pathname: routePaths.bulkUploads.initiate,
        search: `type=${BulkUploadTypes.TYPE_BULK_LOANS_ADVANCES}`,
      });
    },
  },
});
